import {
    ContentChild,
    Directive,
    ElementRef,
    HostListener,
    Input
} from '@angular/core';

/**
 * @description purposely built directive to handle the selection of the card
 */
@Directive({
    selector: '[motorsCardSelection]',
    standalone: false
})
export class CardSelectionDirective {
    /**
     * @description the input element that will be used to set the value of the package,
     * highly depdendent on the template that is used
     *
     */
    @ContentChild('packageInput') packageInput: ElementRef;
    @Input('motorsCardSelection') enableEvent: boolean;

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        if (!this.enableEvent) {
            return;
        }
        event.stopPropagation();
        this.packageInput.nativeElement.dispatchEvent(new Event('change'));
    }
}
